import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Skull Scan"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-skull-scan',
    templateUrl: './icon-skull-scan.component.html',
    styleUrls: ['./icon-skull-scan.component.scss'],
    standalone: false
})
export class IconSkullScanComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
